import {Component, h, Prop} from '@stencil/core';

@Component({
    tag: 'joy-availability',
    styleUrl: 'availability.scss',
    shadow: true,
})
export class Availability {
    /** Text Availability content, if null, only dot will be display */
    @Prop() label?: string;

    /** Status Availability, define color */
    @Prop({reflect: true}) status: 'AVAILABLE' | 'AVAILABLE_AND_VERIFIED' | 'NOT_AVAILABLE_WITH_DATE' | 'AVAILABLE_SOON' | 'NOT_AVAILABLE' | '' = '';

    /** isPartial dot, define fill or stroke dot display */
    @Prop({reflect: true}) isPartial = false;

    get dotClass() {
        return {
            'joy-availability__dot': true,
            'joy-availability--partial': this.isPartial,
            [this.status]: true,
        };
    }

    render() {
        if (this.label) {
            return (
                <div
                    class={{
                        'joy-availability': true,
                        'joy-availability-has-label': !!this.label,
                    }}
                >
                    <span class={this.dotClass}></span>
                    {this.label}
                </div>
            );
        } else {
            return <span class={this.dotClass}></span>;
        }
    }
}
